// src/components/chatBox/Chat.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot } from '@fortawesome/free-solid-svg-icons';
import io from 'socket.io-client';
import MsgBox from './MsgBox';

const Chat = ({ PerfectScrollbar, toggleChatBox, toggleTab }) => {
  const [openMsg, setOpenMsg] = useState(false);
  const [socket, setSocket] = useState(null);
  const [sessionId, setSessionId] = useState(null);

  // Initialize socket once when component mounts
  /*useEffect(() => {
    const newSocket = io('http://localhost:3004');

    // Add connection error handling
    newSocket.on('connect_error', (error) => {
      console.error('Socket connection error:', error);
    });

    setSocket(newSocket);

    // Cleanup on unmount
    return () => {
      if (newSocket) {
        newSocket.disconnect();
      }
    };
  }, []);
  */

  const startNewChat = () => {
    const newSessionId = `session_${Date.now()}`;
    setSessionId(newSessionId);
    setOpenMsg(true);
  };

  return (
    <div className={`tab-pane fade ${toggleTab === 'chat' ? 'active show' : ''}`} id="chat" role="tabpanel">
      <div className={`card mb-sm-3 mb-md-0 contacts_card dlab-chat-user-box ${openMsg ? 'd-none' : ''}`}>
        <div className="card-header chat-list-header text-center">
          <div className="d-flex justify-content-center align-items-center">
            <FontAwesomeIcon icon={faRobot} className="me-2" />
            <div>
              <h6 className="mb-1">Ledgy Assistant</h6>
              <button
                className="btn btn-primary btn-sm"
                onClick={startNewChat}
              >
                Start New Conversation
              </button>
            </div>
          </div>
        </div>
      </div>

      {openMsg && socket && (
        <MsgBox
          sessionId={sessionId}
          socket={socket}
          openMsg={openMsg}
          PerfectScrollbar={PerfectScrollbar}
          offMsg={() => {
            setOpenMsg(false);
            setSessionId(null);
          }}
        />
      )}
    </div>
  );
};

export default Chat;